class Point {
    public static readonly ORIGIN = new Point(0, 0);
    public static readonly UNIT_X = new Point(1, 0);
    public static readonly UNIT_Y = new Point(0, 1);

    public readonly x: number;
    public readonly y: number;

    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    public add(other: Point): Point;
    public add(x: number, y: number): Point;
    public add(a1: number | Point, a2?: number) {
        const p = Point.from(a1, a2);
        return new Point(this.x + p.x, this.y + p.y);
    }

    public subtract(other: Point): Point;
    public subtract(x: number, y: number): Point;
    public subtract(a1: number | Point, a2?: number) {
        return this.add(Point.from(a1, a2).scale(-1));
    }

    public distance(other: Point): number;
    public distance(x: number, y: number): number;
    public distance(a1: number | Point, a2?: number) {
        const other = Point.from(a1, a2);
        return Math.sqrt((this.x - other.x) ** 2 + (this.y - other.y) ** 2);
    }

    public scale(factor: number): Point {
        return new Point(factor * this.x, factor * this.y);
    }

    public setX(newX: number) {
        return new Point(newX, this.y);
    }

    public setY(newY: number) {
        return new Point(this.x, newY);
    }

    public addX(dx: number) {
        return this.add(dx, 0);
    }

    public addY(dy: number) {
        return this.add(0, dy);
    }

    public get tuple(): [number, number] {
        return [this.x, this.y];
    }

    public static from(point: Point): Point;
    public static from(x: number, y: number): Point;
    public static from(a1: Point | number, a2?: number): Point;
    public static from(a1: Point | number, a2?: number): Point {
        if (a1 instanceof Point) return a1;
        return new Point(a1, a2 ?? 0);
    }
}

export { Point };
